export default "__VITE_ASSET__O9xLr1Bg__"